module.exports = __webpack_public_path__ + "static/assets/6ea9ac3ea5795982e00c19c6221a7ef7.svg";